/** Store domains dùng cho lọc (navbar + trang Store). */
export const PREDEFINED_STORE_FILTERS = [
  "jeffoverip.com",
  "thebowmenproshop.com",
  "shopsonicx.com",
  "reptilaw.com",
  "tightsweaters.com",
];

export function mergeStoreFilterOptions(apiStores = []) {
  const fromApi = apiStores.map(([name]) => name).filter(Boolean);
  return [...new Set([...PREDEFINED_STORE_FILTERS, ...fromApi])];
}
